import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import avtar from '../../assets/images/avtar.png';
import { DEFAULT_APP_DOWNLOAD_URL } from '../../config/appDownload';

const MobileBottomBar = () => {
  const [showProfileOffcanvas, setShowProfileOffcanvas] = useState(false);
  const [showSearchCanvas, setShowSearchCanvas] = useState(false);
  const { user, isLogin } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const location = useLocation();

  const handleLogout = () => {
    // Add logout logic here
    setShowProfileOffcanvas(false);
  };

  const handleSearchClick = () => {
    setShowSearchCanvas(true);
    // Trigger the search canvas to open
    const searchCanvas = document.getElementById('search-canvas');
    if (searchCanvas) {
      // Remove any existing Bootstrap offcanvas instances
      const existingInstance = window.bootstrap?.Offcanvas.getInstance(searchCanvas);
      if (existingInstance) {
        existingInstance.dispose();
      }
      
      // Create new Bootstrap offcanvas instance and show it
      if (window.bootstrap) {
        const bsOffcanvas = new window.bootstrap.Offcanvas(searchCanvas);
        bsOffcanvas.show();
      }
    }
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  // Close offcanvas when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showProfileOffcanvas && !event.target.closest('.offcanvas') && !event.target.closest('.mobile-bottom-bar')) {
        setShowProfileOffcanvas(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showProfileOffcanvas]);

  // Listen for search canvas close events
  useEffect(() => {
    const handleSearchCanvasClose = () => {
      setShowSearchCanvas(false);
    };

    const searchCanvas = document.getElementById('search-canvas');
    if (searchCanvas) {
      searchCanvas.addEventListener('hidden.bs.offcanvas', handleSearchCanvasClose);
    }

    return () => {
      if (searchCanvas) {
        searchCanvas.removeEventListener('hidden.bs.offcanvas', handleSearchCanvasClose);
      }
    };
  }, []);

  return (
    <>
      <div className="mobile-bottom-bar">
        <Link
          to="/"
          className={`d-flex flex-column align-items-center gap-1 text-decoration-none ${isActive('/') ? 'active' : ''}`}
        >
          <i className="fas fa-home icon-sizing"></i>
          <span className="fnav-text">Home</span>
        </Link>
        {/* <Link to="/my-order" className={`d-flex flex-column align-items-center gap-1 text-decoration-none ${isActive('/my-order') ? 'active' : ''}`}><i className="fas fa-shopping-bag icon-sizing"></i><span className="fnav-text">My orders</span></Link> */}
        <a
          href={DEFAULT_APP_DOWNLOAD_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="d-flex flex-column align-items-center gap-1 text-decoration-none"
        >
          <i className="fas fa-shopping-bag icon-sizing"></i>
          <span className="fnav-text">My orders</span>
        </a>
        <button
          className={`d-flex flex-column align-items-center gap-1 text-decoration-none border-0 bg-transparent ${showSearchCanvas ? 'active' : ''}`}
          onClick={handleSearchClick}
        >
          <i className="fas fa-search icon-sizing"></i>
          <span className="fnav-text">Search</span>
        </button>
        <button
          className={`d-flex flex-column align-items-center gap-1 text-decoration-none border-0 bg-transparent ${showProfileOffcanvas ? 'active' : ''}`}
          onClick={() => setShowProfileOffcanvas(!showProfileOffcanvas)}
        >
          <i className="fas fa-bars icon-sizing"></i>
          <span className="fnav-text">Menu</span>
        </button>
      </div>

      {/* Profile Offcanvas */}
      <div className={`offcanvas offcanvas-end ${showProfileOffcanvas ? 'show' : ''}`} 
           tabIndex="-1" 
           id="profileOffcanvas" 
           aria-labelledby="profileOffcanvasLabel"
           style={{ width: '75%' }}>
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="profileOffcanvasLabel">Profile Menu</h5>
          <button type="button" 
                  className="btn-close text-reset" 
                  onClick={() => setShowProfileOffcanvas(false)}
                  aria-label="Close"></button>
        </div>
        <div className="offcanvas-body">
          {isLogin ? (
            <>
              <div className="d-flex align-items-center justify-content-between px-3 py-2">
                <div>
                  <img
                    src={user?.profile || avtar}
                    alt="profile"
                    className="rounded-circle prof-img me-2"
                    width="32"
                    height="32"
                  />
                  <span>{user?.name || "Profile"}</span>
                </div>
              </div>
              <ul className="list-group">
                <li>
                  <Link
                    to="/profile"
                    onClick={() => setShowProfileOffcanvas(false)}
                    className="list-group-item"
                  >
                    <i className="fas fa-user-circle me-2" />
                    Your Profile
                  </Link>
                </li>
                <li>
                  <Link
                    to="/wallet"
                    onClick={() => setShowProfileOffcanvas(false)}
                    className="list-group-item"
                  >
                    <i className="fas fa-wallet me-2" /> Your Wallet
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact-us"
                    onClick={() => setShowProfileOffcanvas(false)}
                    className="list-group-item"
                  >
                    <i className="fa-solid fa-headset me-2" /> Contact Us
                  </Link>
                </li>
                <li>
                  {/* <Link to="/my-order" onClick={() => setShowProfileOffcanvas(false)} className="list-group-item"><i className="fas fa-shopping-basket me-2" /> Your Orders</Link> */}
                  <a
                    href={DEFAULT_APP_DOWNLOAD_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => setShowProfileOffcanvas(false)}
                    className="list-group-item"
                  >
                    <i className="fas fa-shopping-basket me-2" /> Your Orders
                  </a>
                </li>
                <li>
                  <Link
                    to="/favourite"
                    onClick={() => setShowProfileOffcanvas(false)}
                    className="list-group-item"
                  >
                    <i className="fas fa-heart me-2" /> Favourites
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about-us"
                    onClick={() => setShowProfileOffcanvas(false)}
                    className="list-group-item"
                  >
                    <i className="fas fa-address-card me-2" /> About Us
                  </Link>
                </li>
                <li>
                  <button
                    className="list-group-item border-0 w-100 text-start"
                    onClick={handleLogout}
                  >
                    <i className="fas fa-sign-out-alt me-2" />
                    Logout
                  </button>
                </li>
              </ul>
            </>
          ) : (
            <div className="text-center">
              <p>Please login to access your profile</p>
              <Link to="/login" className="btn btn-primary" onClick={() => setShowProfileOffcanvas(false)}>
                Login
              </Link>
            </div>
          )}
        </div>
      </div>

      {/* Offcanvas Backdrop */}
      {showProfileOffcanvas && (
        <div className="offcanvas-backdrop fade show" onClick={() => setShowProfileOffcanvas(false)}></div>
      )}
    </>
  );
};

export default MobileBottomBar; 